import {
    FETCH_CONTRATO_DATA, FETCH_CONTRATO_SUCCESS, FETCH_CONTRATO_FAILURE,
} from '../actions/types';

const initialState = {
    isLoading: false
}

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_CONTRATO_DATA:
            return {
                ...state,
                isLoading: true
            };

        case FETCH_CONTRATO_SUCCESS:
            return {
                ...state,
                payload: action.payload,
                isLoading: false
            };

        case FETCH_CONTRATO_FAILURE:
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
            
        default:
            return state;
    }
}

export default reducer;